import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Injectable,
  NgModule,
  OnDestroy,
  OnInit
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidemenuService {
  private readonly menu$ = new BehaviorSubject<any[]>([]);

  setMenuList(menu: any[]): void {
    this.menu$.next(menu || []);
  }

  getMenuList() {
    return this.menu$.asObservable();
  }
}

@Component({
  standalone: false,
  selector: 'app-sidemenu',
  template: `
    <div
      class="app-sidemenu"
      [class.toggled]="toggled"
      [ngClass]="sidemenuClass"
    >
      <div class="menu-header" *ngIf="showHeaderRouteTitle">
        {{ sidemenuTitle }}
      </div>
      <ul class="menu-list">
        <li *ngFor="let item of menu">
          <a
            [routerLink]="item.routerLink || item.link"
            (click)="onLinkClick()"
          >
            <i *ngIf="item.icon" [class]="item.icon" class="mr-2"></i>
            <span>{{ item.title }}</span>
          </a>
          <ul *ngIf="item.submenus?.length">
            <li *ngFor="let sub of item.submenus">
              <a
                [routerLink]="sub.routerLink || sub.link"
                (click)="onLinkClick()"
              >
                <i *ngIf="sub.icon" [class]="sub.icon" class="mr-2"></i>
                <span>{{ sub.title }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit, OnDestroy {
  @Input() sidemenuTitle = '';
  @Input() showHeaderRouteTitle = false;
  @Input() toogleOnLink = false;
  @Input() toggled = false;
  @Input() sidemenuClass = '';
  @Input() menuList: any[] = [];

  menu: any[] = [];
  private sub?: Subscription;

  constructor(private svc: SidemenuService) {}

  ngOnInit(): void {
    this.menu = this.menuList;
    this.sub = this.svc.getMenuList().subscribe(list => {
      this.menu = list && list.length ? list : this.menuList;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onLinkClick(): void {
    if (this.toogleOnLink) {
      this.toggled = !this.toggled;
    }
  }
}

@NgModule({
  declarations: [SidemenuComponent],
  imports: [CommonModule, RouterModule],
  exports: [SidemenuComponent]
})
export class SidemenuModule {}
